import { useContext } from "react";

import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
} from "@stadium/ui/src/components/ModalNew/utils";
import Portal from "@stadium/ui/src/components/portal";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import GlobalProductSearch from "@sharedComponents/global-new-search/global-product-search";

import styles from "./main.module.scss";

const SearchModal = ({ closeModal }: { closeModal: () => void }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  return (
    <Portal id="modal-root" dataContainerId="search-modal">
      <BottomIconHideWrapper hideIcon={isMobileDevice}>
        <Modal closeModal={closeModal} className={styles.headerSearchModal} addTopMargin={false}>
          <ModalDialog className={styles.headerSearchModalDialog}>
            <ModalContent className={styles.headerSearchModalContent}>
              <ModalHeader className={styles.headerSearchModalHeader}>
                <div>Search</div>
                <CloseButton onClick={closeModal} className={styles.headerSearchModalCloseBtn} />
              </ModalHeader>
              <ModalBody>
                <GlobalProductSearch styles={styles} handleClick={closeModal} focusInputOnMount />
              </ModalBody>
            </ModalContent>
          </ModalDialog>
        </Modal>
      </BottomIconHideWrapper>
    </Portal>
  );
};

export default SearchModal;
